import { DamagedItemStatus, OrderItemStatus } from '../interfaces/index.types';
import { IMultiOrder, IOrders } from '../pages/Dashboard/order.types';

const statusPriority: Partial<Record<OrderItemStatus, number>> = {
  [OrderItemStatus.PREPARING]: 1,
  [OrderItemStatus.DAMAGED_PREPARING]: 1,
  [OrderItemStatus.READY_FOR_PICK_UP]: 2,
  [OrderItemStatus.DAMAGED_READY_FOR_PICK_UP]: 2,
  [OrderItemStatus.DELIVERING]: 3,
  [OrderItemStatus.DAMAGED_DELIVERING]: 3,
  [OrderItemStatus.DELIVERED]: 4,
};

export const multiOrderIndicator = (row: IOrders) => {
  if (!row.multi_orders?.length) return '-';

  const doneOrders = row.multi_orders.filter(
    (order) =>
      !(
        [
          OrderItemStatus.PREPARING,
          OrderItemStatus.DAMAGED_PREPARING,
          OrderItemStatus.CANCELLED,
          DamagedItemStatus.DAMAGED_CREATED,
          DamagedItemStatus.DAMAGED_CANCELLED,
        ] as string[]
      ).includes(order.status) && !!order.rider_id
  );

  return `${doneOrders.length}/${row.multi_orders.length}`;
};

export const isAllMatch = (multi_orders: IMultiOrder[], status: OrderItemStatus): boolean => {
  const allStatusesSatisfied = multi_orders
    ?.filter((order) => order.status !== OrderItemStatus.CANCELLED)
    ?.every((item) => {
      const priority = statusPriority[item.status as OrderItemStatus];
      return priority && priority >= (statusPriority[status] as number);
    });

  if (allStatusesSatisfied) {
    return true;
  }

  return false;
};
